<template>
  <div>
   <v-card class="offer">
       <v-toolbar
         color="#E72480"
         dark
       >

         <v-toolbar-title style="font-weight: bold;font-size: 2rem">پیشنهادات</v-toolbar-title>

         <v-spacer></v-spacer>

         <v-btn icon @click="addDialog" >
           <v-icon>mdi-plus-thick  </v-icon>
         </v-btn>
       </v-toolbar>
     <div class="empty-array" v-if="originalOffer.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
     <div class="empty-array" v-if="originalOffer.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
     <div  class="child-offer">
       <v-card
         v-for="item in originalOffer"
         max-width="344"
       >
         <div class="image">
           <v-img
              v-if="isData"
             :src="item.file ? baseUrl+item.file+ '?'+ dates : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'"
              height="250px"
             lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
         ><template v-slot:placeholder>
             <v-row
               class="fill-height ma-0"
               align="center"
               justify="center"
             >
               <v-progress-circular
                 indeterminate
                 color="grey lighten-5"
               ></v-progress-circular>
             </v-row>
           </template>
           </v-img>
           <div class="icons">
             <v-btn :loading="deleteLoading" style="background-color: white" @click="deleteData(item.id)" icon>
               <v-icon color="red">mdi-delete  </v-icon>
             </v-btn>
             <v-btn @click="editData(item.file , item.text , item.id)" style="background-color: white" icon>
               <v-icon color="blue" >mdi-pencil  </v-icon>
             </v-btn>
           </div>
       </div>
           <v-divider></v-divider>
           <v-card-text style="display: flex">
             <div class="ml-1" style="font-weight: bold">نوشته روی عکس:</div>
             <div v-if="item.text">{{item.text}}</div>
             <div v-else>نوشته ای موجود نیست</div>
           </v-card-text>
       </v-card>
     </div>
   </v-card>
    <v-dialog
      v-model="dialog"
      max-width="800"
      v-on:click:outside="eybiyokh"
    >
      <v-card style="background-color: #d2d2d2;padding: 40px">
        <v-form  ref="from" v-model="valid">
          <v-container >
            <v-row>
              <v-file-input
                v-model="files"
                class="input"
                chips
                placeholder=""
                accept="image/png, image/jpeg, image/bmp"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                prepend-icon="mdi-camera"
              ></v-file-input>
              <p class="text">عکس مورد نظر خود را اپلود کنید</p>
            </v-row>
          </v-container>

          <v-textarea
            class="text-input"
            counter
            label="متن اسلایدر مورد نظر را وارد کنید"
            row-height="5"
            v-model="text"
            rows="2"
            :rules="[offerRule]"
            required
          ></v-textarea>
        </v-form>

         <v-img max-width="300" max-height="200" :src="image"></v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="eybiyokh()"
          >
            بیخیال
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            @click="sendData"
            v-show="!isEdit"
            :disabled="!valid"
            :loading="sendLoading"
          >
            انجام شد
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            @click="recordData"
            :loading="editLoading"
            v-show="isEdit"
            :disabled="!valid"

          >
            ویرایش کنید.
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {toBase64} from "../../../plugins/toBase64";
    import {deleteOffer, setOffer,putOffer} from "../../../api/mainpage/offer";
    import {mapActions, mapGetters} from "vuex";
    export default {
        name: "offer",
      data:()=>({
        baseUrl:'',
        dialog:false,
        isEdit:false,
        id:0,
        text:'',
        files:[],
        fileCheck:true,
        textCheck:true,
        check:true,
        valid:true,
        sendLoading:false,
        editLoading:false,
        deleteLoading:false,
        params:{file:'',text:'',id:''},
        image:'',
        isData:false,
        dates:'',
        offerRule: v =>{
          if(v.length <=25)
          {
            return true
          }
          else
          {
            return 'تیتر وارد شده باید کمتر از ۲۵ کاراکتر باشد.'
          }
        },
      }),
      methods:{
        showImage(e){
          if(e) {
            this.image = URL.createObjectURL(e)
          }
        },
        deleteImage()
        {
          this.image = ''
        },
          addDialog () {
            this.isEdit = false
            this.dialog = true
          },
         async sendData(){
          this.sendLoading = true
          try{
            await toBase64(this.files).then((image)=>
            {
              setOffer({
                imgPath:image,
                text:this.text
              }).then(()=>{
                this.getOfferReq()
              })
            })
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            this.dates = new Date()
          }catch(e)
          {
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
          this.sendLoading =false
            this.dialog = false
            this.files=[]
            this.text=''
            this.image = ''
          },
          async recordData(){
           this.editLoading = true
            if(!this.files.name)
            {
              try {
                await  putOffer({
                  imgPath:null,
                  text:this.text
                }, this.id).then(() => {
                  this.getOfferReq()
                  this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
                  this.dates = new Date ()
                }).catch(()=>{
                  this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
                })
              }catch(e){
               ////
              }
            }
            else {
                 let img =  await toBase64(this.files)
                this.params.id = this.id
                this.params.imgPath = img
                this.params.text = this.text
                try{
                  await putOffer(this.params, this.id).then(() => {
                    this.getOfferReq()
                    this.dates = new Date ()
                    this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
                  }).catch(()=>{
                    this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
                  })
                }catch(e){
///
                }

            }

            this.files = []
            this.text = ''
            this.image = ''
            await this.$mount()
            this.editLoading = false
            this.dialog = false
          },
          eybiyokh(){
              this.dialog = false
              this.files=[]
              this.text=''
              this.image = ''
          },
          async deleteData(id){
           this.editLoading = true
            let yes = confirm("مطمئنی میخوای پاک کنی!");
            if (yes) {
              this.files=[]
              try{
                await deleteOffer(id).then(() => {
                  this.getOfferReq()
                  this.dates = new Date ()
                  this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
                }).catch(()=>{
                  this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})

                })
              }catch (e) {
///
              }

            }
            this.editLoading = false
          },
          editData(image, text , id){
            this.image = this.baseUrl+image+'?'+this.dates
            this.text = text
            this.id=id
            this.dialog = true
            this.isEdit = true
          },
        ...mapActions({
          getOfferReq:'MainPageOfferStore/fetchOffer',
          snackBarAction:'snackBar/snackBarAction'

        }),
      },
      computed: {
        ...mapGetters({
          originalOffer: 'MainPageOfferStore/get_offer',
        })
      },

      mounted() {
          this.dates = new Date()
          this.baseUrl = process.env.VUE_APP_BASE_URL
        this.isData= true
          this.getOfferReq()
      },
    }
</script>
<style>
 .offer .v-icon.v-icon::after{
    background-color: unset;
  }
  .text-input .v-label.v-label  {
    font-size: 1.1rem !important;
    top: 0;
  }
  .text-input .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 2rem !important;
  }
  .text-input .v-textarea textarea{
    font-size: 1.25rem;
  }
  .text-input{
    margin-bottom: 2.5rem;
  }
  .date-input{
    margin-bottom: 2rem;
  }
 .offer .v-responsive__content{
   width: 344px !important;
 }
</style>

<style scoped>
 .offer{
   width: 85%;
   margin: 0 auto 100px;
 }
  .child-offer{
    padding: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .card-offer{
    margin: 0;
  }
 .form-slider{
   display: flex;
   flex-direction: column;
   max-width: 1185px;
   margin: 0 auto;
 }
 .title-input
 {
   min-height: unset;
 }
 .input{
   direction: ltr;
 }
 .row{
   justify-content: center;
   align-items: flex-end;
   flex-direction: row-reverse;
 }
 .text{
   font-family: anjoman;
   font-size: 1.25rem;
 }

 .link-input{
   width: 40%;
 }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
</style>
